import type { ContextAgent } from "@/shared/types";
import type { ContextPick } from "./types";

/** Builder's picker set to an agent, under the name it goes by now. */
export const pickOf = ({ id, name }: ContextAgent): ContextPick => ({ kind: "agent", agent: { id, name } });
